import {
  BasicTable,
  ComfirmButton,
  CustomModal,
  PageTitle,
  Status,
} from "@/components";
import {
  ACTIVE,
  INACTIVE,
  PageEnum,
  SOFT_GRID,
  TABLEPAI,
} from "@/enums/pageEnum";
import {
  editOrganization,
  putResume,
  putSuspend,
  getOrganInfo,
  userInvite,
} from "@api";
import { useAppSelector } from "@/store";
import { GetEamilInput } from "@/utils/commonConfig";
import { getTimeToString } from "@/utils/toolt";
import {
  PageContainer,
  ProFormText,
  ProSkeleton,
} from "@ant-design/pro-components";
import { App } from "antd";
import { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

export default function OrganizationDetail() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { message } = App.useApp();
  const userName = useAppSelector((state) => state.app.userName);
  const [data, setData] = useState<any>();
  const [refreshKey, setRefreshKey] = useState<number>();
  useEffect(() => {
    if (!id) return;
    getOrganInfo(id).then((res: any) => {
      setData(res.data.body);
    });
  }, [id]);
  const isActive = useMemo(() => {
    return data?.status === ACTIVE;
  }, [data]);
  const columns = [
    {
      title: t("date"),
      dataIndex: "createdAt",
      renderText: (text: number) => <>{getTimeToString(text)}</>,
    },
    {
      title: t("status"),
      dataIndex: "status",
      renderText: (_: string, record: { email: string; type: string }) => {
        if (record?.type === "JOIN") {
          return <>Admin user “{record?.email}” joined</>;
        }
        return <>Send invitation to “{record?.email}”</>;
      },
    },
  ];
  if (!data) {
    return (
      <ProSkeleton type="descriptions" pageHeader={false} active={false} />
    );
  }
  return (
    <div className="bg-[#f2f2f2] dark:bg-[#000] detailClass">
      <PageTitle title={t("organDetail")} />
      <PageContainer
        header={{
          title: <span className="text-[20px] font-medium">{data?.name}</span>,
          subTitle: <Status status={data?.status} />,
          children: (
            <div className="font-medium mb-5">
              <span>
                {t("type")}: {t(data?.type)}
              </span>
            </div>
          ),
          extra: [
            data?.type !== SOFT_GRID ? (
              <span key="1">
                <CustomModal
                  title={t("rename")}
                  onClick={(values) => {
                    setData((prve: any) => ({ ...prve, name: values.name }));
                  }}
                  initValues={{ name: data?.name }}
                  otherParams={{ id }}
                  request={editOrganization}
                >
                  <ProFormText
                    name="name"
                    label={t("orgaName")}
                    rules={[{ required: true }]}
                  />
                </CustomModal>
              </span>
            ) : null,
            data?.name !== userName ? (
              <span className="ml-2" key={2}>
                <ComfirmButton
                  onClick={async () => {
                    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                    isActive
                      ? await putSuspend([id || ""])
                      : await putResume([id || ""]);
                    message.success("Success");
                    setData((prve: any) => ({
                      ...prve,
                      status: isActive ? INACTIVE : ACTIVE,
                    }));
                  }}
                  popTitle={t("hint.deleteTitle", {
                    name: isActive ? t("suspend") : t("resume"),
                  })}
                  description={t("hint.deleteTask", {
                    name: isActive ? t("suspend") : t("resume"),
                  })}
                  title={isActive ? t("suspend") : t("resume")}
                />
              </span>
            ) : null,
          ],
          breadcrumb: {
            items: [
              {
                title: (
                  <Link to={PageEnum.ORGANIZATION}>{t("organization")}</Link>
                ),
              },
              { title: t("detail") },
            ],
          },
        }}
      >
        <BasicTable
          columns={columns}
          key={refreshKey}
          headerTitle={() => t("invitationRecord")}
          isShowCheckbox={false}
          isDefaultToolBar={false}
          className="!min-h-[calc(100vh-261px)]"
          tableHeader={() => (
            <CustomModal
              title={t("inviteAdmin")}
              otherParams={{ organizationId: id }}
              request={userInvite}
              buttonCogfig={{ disabled: !isActive }}
              onClick={() => setRefreshKey(Math.random())}
            >
              {GetEamilInput(t("email"))}
              <div className="text-[#666] pb-8 pl-[150px]">
                {t("hint.addInvite")}
              </div>
            </CustomModal>
          )}
          requestUrl={`${TABLEPAI.INVITEHIS}?organizationId=${id}`}
        />
      </PageContainer>
    </div>
  );
}
